<template>
  <template v-if="isInvalid">
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 400px; text-align: center;">
      <el-empty description="La página a la que intenta ingresar no existe." />
    </div>
  </template>
  <template v-else-if="isOk && readyToRender">
  <el-container >
    <el-header>
      <span style="font-size: 24px">Formulario solicitud de crédito
        {{ numberform == 1 ? "deudor" : "codeudor" }} </span>
      <template v-if="token">
        <el-col :span="24">
          <p>
            <b>Deudor:</b> {{ infodeudor.deudor }}
            <br />
            <b>Fecha de solicitud:</b> {{ infodeudor.fecha_solicitud }}
            <br />
            <b>Monto solicitado:</b> {{ infodeudor.monto_solicitado }}
            <br />
            <b>Plazo solicitado:</b> {{ infodeudor.plazo_solicitado }}
          </p>
        </el-col>
      </template>
    </el-header>
    <el-main>
      <div v-if="token" style="margin-top: 60px;" />
      <el-form v-if="!sendform" ref="formRef" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="!token">
            <el-form-item label="Asesor (Si lo tiene)">
              <el-select v-model="formData.sowe_asesor_codigo" clearable filterable>
                <el-option v-for="item in asesores" :key="item.id" :value="item.id" :label="item.descripcion" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_id_persona" prop="sowe_id_persona" label="Documento de Identidad" required
              :error="!validateDocumentoIdentidad ? 'El documento debe tener entre 6 y 10 dígitos.' : ''">
              <el-input v-model="formData.sowe_id_persona" type="number"
                @input="(val) => toUpper('sowe_id_persona', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_fecha_expedicion" prop="sowe_fecha_expedicion" label="Fecha expedición documento"
              required>
              <el-date-picker v-model="formData.sowe_fecha_expedicion" type="date"
                placeholder="AAAA-MM-DD"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_primer_nombre" prop="sowe_primer_nombre" label="Primer Nombre" required>
              <el-input v-model="formData.sowe_primer_nombre" type="text"
                @input="(val) => toUpper('sowe_primer_nombre', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_segundo_nombre" label="Otros Nombres (Si lo tiene)">
              <el-input v-model="formData.sowe_segundo_nombre" type="text"
                @input="(val) => toUpper('sowe_segundo_nombre', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_primer_apellido" prop="sowe_primer_apellido" label="Primer Apellido" required>
              <el-input v-model="formData.sowe_primer_apellido" type="text"
                @input="(val) => toUpper('sowe_primer_apellido', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_segundo_apellido" label="Otros Apellidos (Si lo tiene)">
              <el-input v-model="formData.sowe_segundo_apellido" type="text"
                @input="(val) => toUpper('sowe_segundo_apellido', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_fecha_nacimiento" prop="sowe_fecha_nacimiento" label="Fecha de Nacimiento" required>
              <el-date-picker v-model="formData.sowe_fecha_nacimiento" type="date"
                placeholder="AAAA-MM-DD"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_sexo" label="Género" prop="sowe_sexo" required>
              <el-select v-model="formData.sowe_sexo" filterable placeholder="Seleccionar">
                <el-option label="Masculino" value="M"></el-option>
                <el-option label="Femenino" value="F"></el-option>
                <el-option label="No Binario" value="B"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_id_estudio" label="Título Académico" prop="sowe_id_estudio" required>
              <el-select v-model="formData.sowe_id_estudio" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listTiposNivelEscolar" :key="i" :label="item.descripcion"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_telefono" label="Teléfono Móvil" prop="sowe_telefono" required>
              <el-input v-model="formData.sowe_telefono" type="tel" maxlength="10" placeholder=""
                @input="(val) => toUpper('sowe_telefono', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_email" label="Dirección de Correo Electrónico" prop="sowe_email" required>
              <el-input v-model="formData.sowe_email" type="email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_dept_id" label="Departamento" prop="sowe_dept_id" required>
              <el-select v-model="formData.sowe_dept_id" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listDepartamentosFiltro" :key="i" :label="item.depa_descripcion"
                  :value="item.depa_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_muni_id" label="Ciudad" prop="sowe_muni_id" required>
              <el-select v-model="formData.sowe_muni_id" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listMunicipios" :key="i" :label="item.nombre"
                  :value="item.cod_municipio"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_barrio" label="Barrio" prop="sowe_barrio" required>
              <el-input v-model="formData.sowe_barrio" type="text"
                @input="(val) => toUpper('sowe_barrio', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_direccion" label="Dirección Residencia" prop="sowe_direccion" required>
              <el-input v-model="formData.sowe_direccion" type="text"
                @input="(val) => toUpper('sowe_direccion', val)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_ingreso_principal" label="Ingresos Mensuales" prop="sowe_ingreso_principal"
              required>
              <CurrencyInput v-model="formData.sowe_ingreso_principal" :min="1" :options=currencyOptions
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_ingreso_otro" label="Otros Ingresos" prop="sowe_ingreso_otro" required>
              <CurrencyInput v-model="formData.sowe_ingreso_otro" :min="0" :options=currencyOptions
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                required />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_egreso_principal" label="Gasto Mensual" prop="sowe_egreso_principal" required
              title="Pagos mensuales que son fijos, tales como: alimentación, arrendamientos, servicios públicos, transporte, aportes a seguridad social, entre otros.">
              <CurrencyInput v-model="formData.sowe_egreso_principal" :min="1" :options=currencyOptions
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;" />
              <small style="display: block; margin-top: 2px; color: #606266; font-size: 12px; line-height:12px;">
                Pagos mensuales que son fijos, tales como: alimentación, arrendamientos, servicios públicos, transporte,
                aportes a seguridad social, entre otros.
              </small>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_egreso_otros" label="Egresos Mensuales" prop="sowe_egreso_otros" required
              title="Pagos mensuales que tienen una temporalidad establecida, tales como: cuotas de créditos, medicina prepagada, entre otros.">
              <CurrencyInput v-model="formData.sowe_egreso_otros" :min="0" :options=currencyOptions
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;" />
              <small style="display: block; margin-top: 2px; color: #606266; font-size: 12px; line-height:12px;">
                Pagos mensuales que tienen una temporalidad establecida, tales como: cuotas de créditos, medicina
                prepagada,
                entre otros.
              </small>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item ref="sowe_situacion_laboral" label="Situación Laboral" prop="sowe_situacion_laboral" required>
              <el-select v-model="formData.sowe_situacion_laboral" placeholder="Seleccionar">
                <el-option value="DEPENDIENTE">Dependiente</el-option>
                <el-option value="INDEPENDIENTE">Independiente</el-option>
                <el-option value="EMPLEADO">Empleado</el-option>
                <el-option value="COMERCIANTE">Comerciante</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Comerciante -->
          <template v-if="formData.sowe_situacion_laboral === 'COMERCIANTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_labora" label="Nombre del Establecimiento" prop="sowe_empresa_labora"
                required>
                <el-input v-model="formData.sowe_empresa_labora"
                  @input="(val) => toUpper('sowe_empresa_labora', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_actual" label="Descripción">
                <el-input v-model="formData.sowe_cargo_actual" prop="sowe_cargo_actual" required
                  @input="(val) => toUpper('sowe_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <!-- Independiente -->
          <template v-if="formData.sowe_situacion_laboral === 'INDEPENDIENTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_profesion" label="Profesión" prop="sowe_profesion">
                <el-input v-model="formData.sowe_profesion" required
                  @input="(val) => toUpper('sowe_profesion', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item ref="sowe_ciiu_id" label="Actividad Comercial" prop="sowe_ciiu_id" required>
                <el-select v-model="formData.sowe_ciiu_id" required clearable filterable>
                  <el-option v-for="(item, i) in listTiposCiiu" :value="item.id" :key="i"
                    :label="item.id + '-' + item.descripcion" />
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <!-- Dependiente Independiente-->
          <template
            v-if="formData.sowe_situacion_laboral == 'INDEPENDIENTE' || formData.sowe_situacion_laboral == 'DEPENDIENTE'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_actual" label="Descripción" prop="sowe_cargo_actual" required>
                <el-input v-model="formData.sowe_cargo_actual"
                  @input="(val) => toUpper('sowe_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>

          <!-- Empleado -->
          <template v-if="formData.sowe_situacion_laboral == 'EMPLEADO'">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_labora" label="Razón Social Empresa" prop="sowe_empresa_labora" required>
                <el-input v-model="formData.sowe_empresa_labora"
                  @input="(val) => toUpper('sowe_empresa_labora', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item ref="sowe_empresa_actividad" label="Actividad Comercial Empresa"
                prop="sowe_empresa_actividad" required>
                <el-select v-model="formData.sowe_empresa_actividad" clearable filterable>
                  <el-option v-for="(item, i) in listTiposCiiu" :value="item.id" :key="i"
                    :label="item.id + '-' + item.descripcion" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_depa_id" label="Departamento Dirección Empresa"
                prop="sowe_empresa_depa_id" required>
                <el-select v-model="formData.sowe_empresa_depa_id" filterable placeholder="Seleccionar">
                  <el-option v-for="(item, i) in listDepartamentos" :key="i" :label="item.depa_descripcion"
                    :value="item.depa_id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_muni_id" label="Ciudad Empresa" prop="sowe_empresa_muni_id" required>
                <el-select v-model="formData.sowe_empresa_muni_id" filterable placeholder="Seleccionar">
                  <el-option v-for="(item, i) in listMunicipiosEmpresa" :key="i" :label="item.nombre"
                    :value="item.cod_municipio"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_barrio" label="Barrio Empresa" prop="sowe_empresa_barrio" required>
                <el-input v-model="formData.sowe_empresa_barrio"
                  @input="(val) => toUpper('sowe_empresa_barrio', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_direccion" label="Dirección Empresa" prop="sowe_empresa_direccion"
                required>
                <el-input v-model="formData.sowe_empresa_direccion"
                  @input="(val) => toUpper('sowe_empresa_direccion', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="Teléfono Empresa" prop="sowe_empresa_telefono" required>
                <el-input v-model="formData.sowe_empresa_telefono"
                  @input="(val) => toUpper('sowe_empresa_telefono', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_empresa_cargo_actual" label="Cargo Actual Empresa"
                prop="sowe_empresa_cargo_actual" required>
                <el-input v-model="formData.sowe_empresa_cargo_actual"
                  @input="(val) => toUpper('sowe_empresa_cargo_actual', val)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item ref="sowe_cargo_descripcion" label="Descripción del Cargo" prop="sowe_cargo_descripcion"
                required>
                <el-input v-model="formData.sowe_cargo_descripcion"
                  @input="(val) => toUpper('sowe_cargo_descripcion', val)"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <!-- Fin empleado-->
        <!--
         <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_linea_id" label="Línea de Crédito" prop="sowe_linea_id" required>
              <el-select v-model="formData.sowe_linea_id" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listTiposLinea" :key="i" :label="item.linea_descripcion"
                  :value="item.linea_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        -->
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_plazo_solicitado" label="Plazo Solicitado" prop="sowe_plazo_solicitado" required>
              <el-select v-model="formData.sowe_plazo_solicitado" filterable placeholder="Seleccionar">
                <el-option v-for="(item, i) in listPlazos" :key="i" :label="item.colipl_plazo"
                  :value="item.colipl_plazo"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_monto_solicitado" label="Monto Solicitado" prop="sowe_monto_solicitado" required>
              <CurrencyInput v-model="formData.sowe_monto_solicitado" :min="580000" :max="29000000"
                :options=currencyOptions
                style="width: 100%; text-align: right; border: 1px solid; border-radius: 5px; border-color: #dcdfe6;"
                required />
            </el-form-item>
          </el-col>
          <!--
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="numberform == 1">
            <el-form-item ref="sowe_gara_id" label="Garantía" required>
              <el-select v-model="formData.sowe_gara_id" placeholder="Seleccionar">
                <el-option v-for="(item, i) in listGarantiass" :key="i" :label="item.descripcion"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          -->
          <!-- Destino/Inversión -->
          <el-col :span="24" v-if="numberform == 1">
            <el-form-item ref="sowe_destino_credito" label="Destino/Inversión" prop="sowe_destino_credito" required>
              <el-input v-model="formData.sowe_destino_credito" type="text"
                @input="(val) => toUpper('sowe_destino_credito', val)"></el-input>
            </el-form-item>
          </el-col>

          <!-- Referencias -->
          <el-row :gutter="20">
            <el-col :span="24" v-for="(referencia, index) in formData.sowe_referencias" :key="index"
              style="margin-bottom: 30px; border: 1px solid #ebeef5; border-radius: 8px; padding: 20px;">
              <el-divider>Referencia {{ index + 1 }}</el-divider>
              <el-row :gutter="20">
                <!-- Tipo de Referencia -->
                <el-col :span="12">
                  <el-form-item label="Tipo de Referencia" required>
                    <el-select v-model="referencia.sowe_referencia_tipo_referencia" placeholder="Seleccione tipo"
                      style="width: 100%;" clearable filterable>
                      <el-option v-for="tipo in tiposReferencia" :key="tipo.id" :label="tipo.descripcion" :value="tipo.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- Parentesco -->
                <el-col :span="12">
                  <el-form-item label="Parentesco" required>
                    <el-select v-model="referencia.sowe_referencia_id_parentesco" placeholder="Seleccione parentesco"
                      style="width: 100%;" ref="sowe_referencia_id_parentesco" prop="sowe_referencia_id_parentesco" clearable filterable>
                      <el-option v-for="parentesco in tiposParentesco" :key="parentesco.id" :label="parentesco.descripcion"
                        :value="parentesco.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- Nombre -->
                <el-col :span="12">
                  <el-form-item label="Nombre(s)" required>
                    <el-input v-model="referencia.sowe_referencia_nombre"/>
                  </el-form-item>
                </el-col>
                <!-- Primer Apellido -->
                <el-col :span="12">
                  <el-form-item label="Primer Apellido" required>
                    <el-input v-model="referencia.sowe_referencia_primer_apellido" required/>
                  </el-form-item>
                </el-col>
                <!-- Segundo Apellido -->
                <el-col :span="12">
                  <el-form-item label="Segundo Apellido">
                    <el-input v-model="referencia.sowe_referencia_segundo_apellido" />
                  </el-form-item>
                </el-col>
                <!-- Dirección -->
                <el-col :span="12">
                  <el-form-item label="Dirección">
                    <el-input v-model="referencia.sowe_referencia_direccion" />
                  </el-form-item>
                </el-col>
                <!-- Teléfono -->
                <el-col :span="12">
                  <el-form-item label="Teléfono" required>
                    <el-input v-model="referencia.sowe_referencia_telefono" required/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <el-col v-if="!token" @click="handleisModalOpen(1)" :span="24">
            <el-checkbox ref="sowe_aporte_donacion" v-model="formData.sowe_aporte_donacion" required>
            </el-checkbox>
            <label style="cursor: pointer;">Aporte a Título de Donación
            </label>
          </el-col>
          <el-card>
            <template #header>Autorizaciones Requeridas</template>
            <el-col @click="handleisModalOpen(3)" :span="24">
              <el-checkbox ref="sowe_centrales" v-model="formData.sowe_centrales" required>
              </el-checkbox>
              <label style="cursor: pointer;">Autorización expresa para la consulta a
                centrales
                de información financiera
              </label>
            </el-col>
            <el-col @click="handleisModalOpen(4)" :span="24">
              <el-checkbox ref="sowe_declaracion" v-model="formData.sowe_declaracion" required>
              </el-checkbox>
              <label style="cursor: pointer;">Declaración origen de fondos
              </label>
            </el-col>

            <el-col @click="handleisModalOpen(2)" :span="24">
              <el-checkbox ref="sowe_autoriza_canal" v-model="formData.sowe_autoriza_canal" required>
              </el-checkbox>
              <label style="cursor: pointer;">Autorización expresa de los canales de
                comunicación y contacto
              </label>
            </el-col>
            <el-col @click="handleisModalOpen(5)" :span="24">
              <el-checkbox ref="sowe_tratamiento" v-model="formData.sowe_tratamiento" required>
              </el-checkbox>
              <label style="cursor: pointer;">Autorización expresa para el tratamiento de
                datos
                personales
              </label>
            </el-col>
          </el-card>
          <el-col :span="24" class="text-center">
            <el-popconfirm width="220" title="Seguro de enviar estos datos?" confirm-text="Si" @confirm="submitForm()">
              <template #reference>
                <el-button type="primary">Enviar formulario</el-button>
              </template>
            </el-popconfirm>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <!-- Modal usando el-dialog -->
    <el-dialog v-model="isModalOpen" width="80%" :show-close="false">
      <span>
        <aporteTitul v-if="typenum == 1 && !token" />
        <autorizacion_canales v-if="typenum == 2" />
        <consultacentral v-if="typenum == 3" />
        <declaracionorig v-if="typenum == 4" />
        <tratamientodatos v-if="typenum == 5" />
      </span>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dlgAccept()">Aceptar</el-button>
          <el-button type="warning" @click="dlgReject()">Rechazar</el-button>
        </div>
      </template>
    </el-dialog>
    <div class="mensaje" v-if="sendform" @click="cuenta()">
      <p>
        La solicitud de crédito ha sido radicada, la radicación no implica aceptación.
        <br />
        Por favor consulte el correo electrónico registrado ({{ formData.sowe_email }})
        y siga las instrucciones para continuar con el proceso.
      </p>
      <p>Gracias por preferirnos.</p>
      <p>Redireccionando en ({{ regresiva }})</p>
    </div>
  </el-container>
  </template>
  <template v-else>
    <el-container></el-container>
  </template>
</template>

<style scoped>
.contformInicial h2 {
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 50px;
}

.mensaje {
  padding: 50px;
  text-align: center;
  max-width: 600px;
  margin: auto;
  font-size: 20px;
}

.el-form-item[required]>label.el-form-item--label-top label.el-form-item__labellabel.el-form-item__label::before {
  content: "*";
  /* Cambia el carácter aquí si quieres algo diferente */
  color: green !important;
  /* Fuerza el cambio de color */
  font-weight: bold !important;
  margin-right: 4px !important;
}
</style>
<script>
import CurrencyInput from "./CurrencyInput";
// import axios from 'axios';
// import ModalView from "./ModalContainer";
import {
  getDepartamento,
  getDepartamentoFiltro,
  getTipoLinea,
  getTipoCiiu,
  getTipoNivelEscolar,
  getTipoGarantia,
  getSolicitudToken,
  postSolicitud,
  getMunicipio,
  getAsesores,
  getTipoReferencia,
  getTipoParentesco
} from "@/api/endpoint";
import aporteTitul from '@/components/modals/aporte_titulo_donacion.vue';
import autorizacion_canales from './modals/autorizacion_canales_contacto_comunicacion.vue';
import consultacentral from './modals/consulta_centrales_información_financiera.vue';
import declaracionorig from './modals/declaracion_origen_fondos.vue';
import tratamientodatos from './modals/tratamiento_datos_personales.vue';
// const endpoint = "/";
import { ElLoading } from 'element-plus'
export default {
  props: {
    numberform: Number,
  },
  name: "FormInicialComponent",
  components: {
    CurrencyInput,
    /* ModalView */
    aporteTitul,
    autorizacion_canales,
    consultacentral,
    declaracionorig,
    tratamientodatos
  },
  data() {
    return {
      isInvalid:false,
      readyToRender: false,
      token: null,
      typenum: 1,
      isModalOpen: false,
      sendform: false,
      regresiva: 20,
      valor_minimo: 0,
      valor_maximo: 999999999,
      formData: {
        sowe_asesor_codigo: null,
        sowe_id_identificacion: 3,
        sowe_id_persona: null,
        sowe_fecha_expedicion: null,
        sowe_primer_nombre: "",
        sowe_segundo_nombre: "",
        sowe_primer_apellido: "",
        sowe_segundo_apellido: "",
        sowe_fecha_nacimiento: null,
        sowe_sexo: "",
        sowe_id_estudio: "",
        sowe_telefono: null,
        sowe_email: null,
        sowe_dept_id: "",
        sowe_muni_id: "",
        sowe_barrio: null,
        sowe_direccion: null,
        sowe_ingreso_principal: 0,
        sowe_ingreso_otro: 0,
        sowe_egreso_principal: 0,
        sowe_egreso_otros: 0,
        sowe_situacion_laboral: "",
        sowe_cargo_actual: null,
        sowe_profesion: null,
        sowe_ciiu_id: null,
        sowe_empresa_labora: null,
        sowe_empresa_actividad: "",
        sowe_empresa_depa_id: null,
        sowe_empresa_muni_id: null,
        sowe_empresa_barrio: null,
        sowe_empresa_direccion: null,
        sowe_empresa_telefono: null,
        sowe_empresa_cargo_actual: null,
        sowe_cargo_descripcion: null,
        sowe_linea_id: 0,
        sowe_plazo_solicitado: "",
        sowe_monto_solicitado: 0,
        sowe_gara_id: null,
        sowe_destino_credito: null,
        sowe_aporte_donacion: null,
        sowe_canal_contacto: null,
        sowe_centrales: null,
        sowe_declaracion: null,
        sowe_tratamiento: null,
        sowe_autoriza_canal: null,
        sowe_padre_id: null,
        sowe_referencias: [
          {
            sowe_referencia_tipo_referencia: null,
            sowe_referencia_id_parentesco: null,
            sowe_referencia_nombre: '',
            sowe_referencia_primer_apellido: '',
            sowe_referencia_segundo_apellido: '',
            sowe_referencia_direccion: '',
            sowe_referencia_telefono: '',
          },
          {
            sowe_referencia_tipo_referencia: null,
            sowe_referencia_id_parentesco: null,
            sowe_referencia_nombre: '',
            sowe_referencia_primer_apellido: '',
            sowe_referencia_segundo_apellido: '',
            sowe_referencia_direccion: '',
            sowe_referencia_telefono: '',
          }
        ]
      },
      tiposReferencia: [
        { id: 0, value: "Ninguna" },
      ],
      tiposParentesco: [
        { id: 0, value: "Ninguno" },
      ],
      rules: {
        sowe_id_persona: [
          { required: true, message: "El documento de identidad es obligatorio", trigger: "blur" },
          { pattern: /^[0-9]{6,10}$/, message: "Debe tener entre 6 y 10 dígitos", trigger: "blur" }
        ],
        sowe_fecha_expedicion: [
          { required: true, message: "La fecha de expedición es obligatoria", trigger: "change" }
        ],
        sowe_primer_nombre: [
          { required: true, message: "El primer nombre es obligatorio", trigger: "blur" }
        ],
        sowe_primer_apellido: [
          { required: true, message: "El primer apellido es obligatorio", trigger: "blur" }
        ],
        sowe_fecha_nacimiento: [
          { required: true, message: "La fecha de nacimiento es obligatoria", trigger: "change" }
        ],
        sowe_sexo: [
          { required: true, message: "El género es obligatorio", trigger: "change" }
        ],
        sowe_id_estudio: [
          { required: true, message: "El título académico es obligatorio", trigger: "change" }
        ],
        sowe_telefono: [
          { required: true, message: "El teléfono móvil es obligatorio", trigger: "blur" },
          { pattern: /^[0-9]{10}$/, message: "Debe ser un número de 10 dígitos", trigger: "blur" }
        ],
        sowe_email: [
          { required: true, message: "El correo electrónico es obligatorio", trigger: "blur" },
          { type: "email", message: "Debe ser un correo electrónico válido", trigger: "blur" }
        ],
        sowe_dept_id: [
          { required: true, message: "El departamento es obligatorio", trigger: "change" }
        ],
        sowe_muni_id: [
          { required: true, message: "La ciudad es obligatoria", trigger: "change" }
        ],
        sowe_barrio: [
          { required: true, message: "El barrio es obligatorio", trigger: "blur" }
        ],
        sowe_direccion: [
          { required: true, message: "La dirección de residencia es obligatoria", trigger: "blur" }
        ],
        sowe_ingreso_principal: [
          { required: true, message: "Los ingresos mensuales son obligatorios", trigger: "blur" },
          { type: "number", message: "Debe ser un número válido", trigger: "blur" }
        ],
        sowe_egreso_principal: [
          { required: true, message: "El gasto mensual es obligatorio", trigger: "blur" },
          { type: "number", message: "Debe ser un número válido", trigger: "blur" }
        ],
        sowe_situacion_laboral: [
          { required: true, message: "La situación laboral es obligatoria", trigger: "change" }
        ],
        sowe_centrales: [
          { required: true, message: "Debe aceptar la autorización de consulta a centrales", trigger: "change" }
        ],
        sowe_declaracion: [
          { required: true, message: "Debe aceptar la declaración de origen de fondos", trigger: "change" }
        ],
        sowe_tratamiento: [
          { required: true, message: "Debe aceptar el tratamiento de datos personales", trigger: "change" }
        ],
        sowe_autoriza_canal: [
          { required: true, message: "Debe aceptar la autorización de los canales de comunicación", trigger: "change" }
        ],
      },
      listDepartamentos: [],
      listDepartamentosFiltro: [],
      listMunicipios: [],
      listTiposLinea: [],
      listTiposCiiu: [],
      listTiposVivienda: [],
      listTiposNivelEscolar: [],
      listMunicipiosEmpresa: [],
      listGarantiass: [],
      asesores: [],
      listPlazos: [],
      infodeudor: {
        deudor: "",
        codeudor: "",
        email: "",
        fecha_solicitud: "",
        monto_solicitado: "",
        plazo_solicitado: 0,
      },
      loading: null,
      currencyOptions: {
        "currency": "COP",
        "currencyDisplay": "symbol",
        "hideCurrencySymbolOnFocus": true,
        "hideGroupingSeparatorOnFocus": false,
        "hideNegligibleDecimalDigitsOnFocus": true,
        "autoDecimalDigits": false,
        "useGrouping": true,
        "accountingSign": false
      },
      isOk: false,
      dataGet01: false,
      dataGet02: false,
      dataGet03: false,
      dataGet04: false,
      dataGet05: false,
      dataGet06: false,
      dataGet07: false,
      dataGet08: false,
      dataGet09: false,
      dataGet10: false
    };
  },
  watch: {
    "formData.sowe_dept_id": function () {
      this.listMunicipios = [];
      this.formData.sowe_muni_id = "";
      this.municipios();
    },
    "formData.sowe_empresa_depa_id": function () {
      this.listMunicipiosEmpresa = [];
      this.formData.sowe_empresa_muni_id = "";
      this.municipiosEmpresa();
    },
    sendform: function () {
      this.cuenta();
    },
    //"formData.sowe_linea_id": function (res) {
    //  const lists = this.listTiposLinea.filter((item) => item.linea_id == res);
    //  this.listPlazos = lists[0].linea_plazo;
    //},
    formData: {
      handler(newFormData) {
        // Guarda los datos en localStorage al cambiar
        localStorage.setItem("formDataSolFap", JSON.stringify(newFormData));
      },
      deep: true,
    },
    dataGet01: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet02: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet03: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet04: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet05: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet06: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet07: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet08: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    dataGet09: function () {
      if (this.dataGet01 && this.dataGet02 && this.dataGet03 && this.dataGet04 && this.dataGet05 && this.dataGet06 && this.dataGet07 && this.dataGet08 && this.dataGet09) {
        this.isOk = true;
      }
    },
    isOk: function (value) {
      if (value) {
        const savedFormData = localStorage.getItem("formDataSolFap");
        if (savedFormData) {
          this.formData = JSON.parse(savedFormData);
          if (!this.formData.sowe_referencias || this.formData.sowe_referencias.length === 0) {
            this.formData.sowe_referencias = [
              {
                sowe_referencia_tipo_referencia: null,
                sowe_referencia_id_parentesco: null,
                sowe_referencia_nombre: '',
                sowe_referencia_primer_apellido: '',
                sowe_referencia_segundo_apellido: '',
                sowe_referencia_direccion: '',
                sowe_referencia_telefono: '',
              },
              {
                sowe_referencia_tipo_referencia: null,
                sowe_referencia_id_parentesco: null,
                sowe_referencia_nombre: '',
                sowe_referencia_primer_apellido: '',
                sowe_referencia_segundo_apellido: '',
                sowe_referencia_direccion: '',
                sowe_referencia_telefono: '',
              }
            ]
          }
        }
      }
    },
  },
  computed: {
    validateDocumentoIdentidad() {
      const length = String(this.formData.sowe_id_persona).length;
      return length >= 6 && length <= 10;
    },
    validateEmail() {
      const email = String(this.formData.sowe_email);
      const regex = /\S+@\S+\.\S+/;
      return regex.test(email);
    },
  },
  beforeMount() {
    // Departamento
    // axios.get(`${endpoint}/api/web/tdep01/39913492-498b-44ea-831c-28ba909f5fa4`)
    // Recuperar datos del formulario si existen en localStorage
    this.token = this.$route.query.token;
    console.log('Validar si el token tiene valor: ', this.token);
    const linea_id = 0;
    this.listPlazos = Array.from({ length: 36 }, (_, i) => ({
      linea_id,
      colipl_plazo: i + 1
    }));
    if (this.token) {
      console.log('Validando Token:', this.token);
        //axios.get(`${endpoint}/api/web/tpgso01/${this.token}/39913492-498b-44ea-831c-28ba909f5fa4`)
        getSolicitudToken(this.token)
          .then((response) => {
            if (response.status === 200) {
              this.infodeudor = response.data;
              if (this.infodeudor && this.infodeudor.monto_solicitado && this.infodeudor.monto_solicitado > 0) {
                this.infodeudor.monto_solicitado = new Intl.NumberFormat(
                  "es-CO",
                  { style: "currency", currency: "COP" }
                ).format(this.infodeudor.monto_solicitado);
                this.formData.sowe_email = this.infodeudor.email;
                this.formData.sowe_primer_nombre = this.infodeudor.codeudor;
                this.readyToRender = true;
                this.isOk = true;
                this.isInvalid = false;
                this.$forceUpdate();
              } else {
                this.isInvalid = true
              }
            } else {
              this.isInvalid = true
            }})
          .catch(() => {
            this.isInvalid = true
          });
          this.getSelectorData();
      } else {
        this.getSelectorData();
        this.readyToRender = true;
      }
  },
  methods: {
    getSelectorData() {
      getAsesores().then((response => {
      this.asesores = response.data;
      this.dataGet01 = true;
    }))
    getDepartamento()
      .then((response) => {
        this.listDepartamentos = response.data;
        this.dataGet02 = true;
      })
      .catch((error) => {
        console.log(error);
      });
    getDepartamentoFiltro()
      .then((response) => {
        this.listDepartamentosFiltro = response.data;
        this.dataGet03 = true;
      })
      .catch((error) => {
        console.log(error);
      });
    // Tipos linea
    // axios.get(`${endpoint}/api/web/l01/39913492-498b-44ea-831c-28ba909f5fa4`)
    getTipoLinea()
      .then((response) => {
        this.listTiposLinea = response.data;
        this.dataGet04 = true;
      })
      .catch((error) => {
        console.log(error);
      });

    // Tipos Ciiu
    //axios.get(`${endpoint}/api/web/tciiu01/39913492-498b-44ea-831c-28ba909f5fa4`)
    getTipoCiiu()
      .then((response) => {
        this.listTiposCiiu = response.data;
        this.dataGet05 = true;
      })
      .catch((error) => {
        console.log(error);
      });

    // Tipos nivel escolar
    // axios.get(`${endpoint}/api/web/tnve01/39913492-498b-44ea-831c-28ba909f5fa4`)
    getTipoNivelEscolar()
      .then((response) => {
        this.listTiposNivelEscolar = response.data;
        this.dataGet06 = true;
      })
      .catch((error) => {
        console.log(error);
      });

    // Tipos garantia
    // axios.get(`${endpoint}/api/web/tgar01/39913492-498b-44ea-831c-28ba909f5fa4`)
    getTipoGarantia()
      .then((response) => {
        this.listGarantiass = response.data;
        this.dataGet07 = true;
      })
      .catch((error) => {
        console.log(error);
      });
    getTipoReferencia()
      .then((response) => {
        this.tiposReferencia = response.data.filter((item) => item.id == 1 || item.id == 2);
        this.dataGet08 = true;
      })
      .catch((error) => {
        console.log(error);
      });
    getTipoParentesco()
      .then((response) => {
        this.tiposParentesco = response.data;
        this.dataGet09 = true;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    showLoading() {
      this.loading = ElLoading.service({
        lock: true,
        text: 'Enviando Datos...',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    closeLoading() {
      this.loading.close()
    },
    handleisModalOpen(type) {
      console.log('Cambiando a Dialogo: ', type)
      this.typenum = type
      this.isModalOpen = true
    },
    titleLineaCredito() {
      return 'CrediApoyo -> Credito de Consumo'
    },
    cuenta() {
      this.regresiva = this.regresiva - 1;
      console.log(this.regresiva);
      if (this.regresiva == 0) {
        location.href = "https://fundacionapoyo.com/";
        return;
      }
      setTimeout(() => {
        this.cuenta();
      }, 1000);
    },
    submitForm() {
      console.log("Enviando Formulario")
      if (this.numberform == 2) {
        this.formData.sowe_padre_id = this.token;
      }
      // if (!this.validateEmail) return;
      // axios.post(`${endpoint}/web/tpsol01/39913492-498b-44ea-831c-28ba909f5fa4`,{...this.formData})
      // Validar el formulario
      this.$refs.formRef.validate((valid, fields) => {
        if (valid) {
          this.formData.sowe_fecha_expedicion = new Date(
            this.formData.sowe_fecha_expedicion
          ).getTime();
          this.formData.sowe_fecha_nacimiento = new Date(
            this.formData.sowe_fecha_nacimiento
          ).getTime();
          this.formData.sowe_aporte_donacion = this.formData.sowe_aporte_donacion
            ? 1
            : 0;
          this.formData.sowe_centrales = this.formData.sowe_centrales ? 1 : 0;
          this.formData.sowe_declaracion = this.formData.sowe_declaracion ? 1 : 0;
          this.formData.sowe_tratamiento = this.formData.sowe_tratamiento ? 1 : 0;
          this.formData.sowe_autoriza_canal = this.formData.sowe_autoriza_canal
            ? 1
            : 0;
          this.formData.sowe_plazo_solicitado = parseInt(
            this.formData.sowe_plazo_solicitado
          );
          this.formData.sowe_ciiu_id = parseInt(this.formData.sowe_ciiu_id);
          this.formData.sowe_empresa_actividad = parseInt(
            this.formData.sowe_empresa_actividad
          );
          console.log(this.formData);
          if (this.formData.sowe_centrales == 1 &&
            this.formData.sowe_declaracion == 1 &&
            this.formData.sowe_tratamiento == 1 &&
            this.formData.sowe_autoriza_canal == 1) {
            this.showLoading();
            console.log('Enviando formulario:', this.formData);
            postSolicitud(this.formData)
              .then(() => {
                this.sendform = true;
                localStorage.removeItem("formDataSolFap");
                this.closeLoading();
              })
              .catch((error) => {
                this.closeLoading();
                alert('Error al enviar el formulario, por favor intente nuevamente')
                console.log(error);
              });
          } else {
            alert('Por favor revise que todos los campos requeridos esten diligenciados y acepte los términos y condiciones')
          }
        } else {
          // Si hay errores, desplázate al primer campo con error
          const firstErrorKey = Object.keys(fields)[0]; // Encuentra el primer campo con error
          // Localiza el contenedor de el-form-item basado en el atributo prop
          const firstErrorElement = this.$refs[firstErrorKey].$el;
          console.log('Primer error:', firstErrorKey);
          console.log('Elemento:', firstErrorElement);
          if (firstErrorElement) {
            console.log('Desplazando a:', firstErrorElement);
            firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            firstErrorElement.focus();
          }

        }
      });
    },
    municipios() {
      // axios.get(`${endpoint}/api/web/tmun01/${this.formData.sowe_dept_id}/39913492-498b-44ea-831c-28ba909f5fa4`)
      getMunicipio(this.formData.sowe_dept_id)
        .then((response) => {
          this.listMunicipios = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    municipiosEmpresa() {
      // axios.get(`${endpoint}/api/web/tmun01/${this.formData.sowe_empresa_depa_id}/39913492-498b-44ea-831c-28ba909f5fa4`)
      getMunicipio(this.formData.sowe_empresa_depa_id)
        .then((response) => {
          this.listMunicipiosEmpresa = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dlgAccept() {
      this.isModalOpen = false
      switch (this.typenum) {
        case 1:
          this.formData.sowe_aporte_donacion = true
          break;
        case 2:
          this.formData.sowe_autoriza_canal = true
          break;
        case 3:
          this.formData.sowe_centrales = true
          break;
        case 4:
          this.formData.sowe_declaracion = true
          break;
        case 5:
          this.formData.sowe_tratamiento = true
          break;
      }
    },
    dlgReject() {
      this.isModalOpen = false
      switch (this.typenum) {
        case 1:
          this.formData.sowe_aporte_donacion = false
          break;
        case 2:
          this.formData.sowe_autoriza_canal = false
          break;
        case 3:
          this.formData.sowe_centrales = false
          break;
        case 4:
          this.formData.sowe_declaracion = false
          break;
        case 5:
          this.formData.sowe_tratamiento = false
          break;
      }
    },
    toUpper(campo, valor) {
      // Conviertes el valor a mayúsculas y reasignas a tu variable
      this.formData[campo] = valor.toUpperCase();
    }
  },
};
</script>